/*
  Disciplinares               = 0
                              = 1
                              = 2
  Matemáticas                 = 3
  Formación complementaria    = 4

*/

export const career_data = {
    name: "Ingeniería en Topografía y Catastro con grado de Bachillerato (BA-TOPOGR)",
    code: "BA-TOPOGR",
    mesh: {
        "0 0": {
            "#Disciplinares": [
                "Disciplinares",
                [],
                0
            ],
            "#Física": [
                "Física",
                [],
                2
            ],
            "#Matemáticas": [
                "Matemáticas",
                [],
                3
            ],
            "#Formación complementaria": [
                "Formación complementaria",
                [],
                4
            ]
        },
        "1 1": {
            "TGF400": ["Cálculo Topográfico", ["MAT001"], 0],
            "TGF401": ["Dibujo Topográfico Asistido por Computadora", ["TGF400"], 0],
            "TGF402": ["Geología para Ingeniería", [], 0],
            "MAT001": ["Matemática General", [], 3],
            "GEN1": ["Estudios Generales I", [], 4],
            "GEN2": ["Estudios Generales II", [], 4]
        },
        "1 2": {
            "FIY423": ["Física I", ["MAT001", "MAT002", "FIY423L"], 2],
            "FIY423L": ["Laboratorio para Física I para Topografía", ["MAT001", "MAT002", "FIY423"], 2],
            "MAT002": ["Cálculo I", ["MAT001"], 3],
            "TGF403": ["Topografía I (curso colegiado)", ["TGF400"], 0],
            "GEN3": ["Estudios Generales III", [], 4],
            "GEN4": ["Estudios Generales IV", [], 4]
        },
        "2 1": {
            "TGF404": ["Programación para Ingeniería", ["TGF405"], 0],
            "FIY424": ["Física II para Topografía", ["MAT002", "FIY423", "FIY423L", "FIY424L"], 2],
            "FIY424L": ["Laboratorio para Física II para Topografía", ["MAT002", "FIY423", "FIY423L", "FIY424"], 2],
            "MAT007": ["Cálculo II", ["MAT002"], 3],
            "TGF405": ["Topografía II (curso colegiado)", ["TGF403"], 0],
            "LIX410": ["Inglés Integrado I", [], 4],
        },
        "2 2": {
            "TGF406": ["Sistemas de Información Geográfica I", ["TGF404", "LIX410"], 0],
            "TGF407": ["Legislación Catastral", ["TGF405"], 0],
            "TGF408": ["Sistemas Satelitales de Navegación Global (curso colegiado)", ["FIY424", "FIY424L"], 0],
            "MAT005": ["Álgebra lineal", ["MAT002"], 3],
            "MAT006": ["Probabilidad y estadística", ["MAT002"], 3],
            "LIX411": ["Inglés Integrado II", ["LIX410"], 4],
        },
        "3 1": {
            "TGF409": ["Sistemas de Información Geográfica II", ["TGF406"], 0],
            "TGF410": ["Catastro I (curso colegiado)", ["TGF407"], 0],
            "TGF411": ["Cartografía I", ["TGF408"], 0],
            "TGF412": ["Topografía de Vías I (curso colegiado)", ["TGF413"], 0],
            "TGF413": ["Hidrología", ["MAT006"], 0],
            "OPT1": ["Optativa Libre", [], 5]
        },
        "3 2": {
            "TGF414": ["Fotogrametría I (curso colegiado)", ["TGF409", "TGF416"], 0],
            "TGF415": ["Catastro II (curso colegiado)", ["TGF410"], 0],
            "TGF416": ["Ajuste I", ["MAT005", "MAT006"], 0],
            "TGF417": ["Topografía de Vías II (curso colegiado)", ["TGF412"], 0],
            "OPT2": ["Optativa Disciplinar", [], 5]
        },
        "4 1": {
            "TGF418": ["Fotogrametría II", ["TGF414"], 0],
            "TGF419": ["Sistemas de Información Territorial", ["TGF415"], 1],
            "TGF420": ["Ajuste II", ["TGF416"], 4],
            "TGF421": ["Topografía de Obras Civiles", ["TGF417"], 1],
            "TGF422": ["Avalúos", ["TGF419"], 4],
            "OPT3": ["Optativa Disciplinar", [], 5],
        },
        "4 2": {
            
            "TGF423": ["Diseño de Urbanizaciones", ["TGF421"], 1],
            "TGF424": ["Geodesia Geométrica", ["TGF420"], 4],
            "TGF425": ["Práctica Profesional Supervisada (PPS)", ["1 1", "1 2", "2 1", "2 2", "3 1", "3 2"], 1],
            "TGF426": ["Métodos y Técnicas de Investigación", ["1 1", "1 2", "2 1", "2 2", "3 1", "3 2"], 0],
            "OPT4": ["Optativa Disciplinar", [], 5]
        },
        "Opt": {
            "TGF440O": ["Planificación Regional y Urbana", [], 0],
            "TGF441O": ["Posicionamiento GNSS", [], 0],
            "TGF442O": ["Levantamientos Gravimétricos", [], 0],
            "TGF443O": ["Cartografía Temática Digital", [], 0],
            "TGF444O": ["Análisis Espacial", [], 0],
            "TGF445O": ["Interactuando el Lenguaje de Programación Visual Basic Application con una herramienta de cálculo informático", [], 4],
            "TGF446O": ["Cartografía digital con UAV", [], 0],
        }
    }
};